import { render } from "./phoneNumberInput.vue?vue&type=template&id=321c522e"
import script from "./phoneNumberInput.vue?vue&type=script&lang=js"
export * from "./phoneNumberInput.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__